"use client"
import { useLandingUrl } from "@/app/(site)/_utils/_hooks/useLandingUrl"

export function LandingUrlInitializer() {
    useLandingUrl()
    return null
}
